import { useEffect, useState } from "react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Share, X, Smartphone } from "lucide-react";

const KEY = "convitel_install_hidden";

export default function InstallPrompt() {
  const [visible, setVisible] = useState(false);
  const [deferred, setDeferred] = useState(null);
  const isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent);

  useEffect(() => {
    const standalone = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
    if (standalone || localStorage.getItem(KEY)) return;
    const onPrompt = (e) => { e.preventDefault(); setDeferred(e); setVisible(true); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    if (isIOS) setVisible(true);
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, [isIOS]);

  const hide = () => { localStorage.setItem(KEY, "1"); setVisible(false); };

  if (!visible) return null;

  return (
    <Card className="fixed inset-x-4 bottom-4 z-50 border-slate-200 p-4 shadow-md lg:hidden" data-testid="install-prompt">
      <div className="flex items-start gap-3">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary">
          <Smartphone className="h-5 w-5 text-white" />
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-sm font-semibold tracking-tight">Instala la app en tu móvil</p>
          {isIOS && !deferred ? (
            <p className="mt-1 text-xs leading-relaxed text-muted-foreground">
              Pulsa <Share className="mx-0.5 inline h-3 w-3" /> <strong className="font-medium">Compartir</strong> y después <strong className="font-medium">“Añadir a pantalla de inicio”</strong>.
            </p>
          ) : (
            <p className="mt-1 text-xs leading-relaxed text-muted-foreground">Pantalla completa y acceso directo para firmar entregas en obra.</p>
          )}
          {deferred && (
            <Button size="sm" className="mt-3 h-9 text-xs" data-testid="install-app-button"
              onClick={async () => { deferred.prompt(); await deferred.userChoice; hide(); }}>
              Instalar ahora
            </Button>
          )}
        </div>
        <button onClick={hide} aria-label="Cerrar aviso"
          className="-m-1 shrink-0 rounded p-1 text-slate-400 transition-colors hover:text-slate-700"
          data-testid="install-dismiss-button">
          <X className="h-4 w-4" />
        </button>
      </div>
    </Card>
  );
}
